import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import UserOutlined from '@ant-design/icons/UserOutlined';

// ---- helpers (can be moved to a utils file) ----
function stripBase(pathname, base) {
  const b = String(base || '/').replace(/\/+$/, '');
  if (!b || b === '/') return pathname;
  return pathname.startsWith(b) ? pathname.slice(b.length) || '/' : pathname;
}
function currentPrefix() {
  const base = import.meta.env.VITE_APP_BASE_NAME || '/';
  const effective = stripBase(window.location.pathname, base);
  return /^\/admin(\/|$)/.test(effective) ? '/admin' : '/';
}
function join(base, path) {
  return `${String(base).replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
}

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [userName, setUserName] = useState('');


  // decide the correct profile route based on where we are
  const prefix = currentPrefix();
  // If you don't have a user profile page, change 'profile' -> 'dashboard'
  const profileRoute = prefix === '/admin' ? '/admin/profile' : '/profile';

  const handleListItemClick = (_event, index, route = '') => {
    setSelectedIndex(index);
    if (route) navigate(route);
  };

  useEffect(() => {
    setSelectedIndex(location.pathname === profileRoute ? 0 : undefined);
  }, [location.pathname, profileRoute]);

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {/* <ListItemButton
        selected={selectedIndex === 0}
        onClick={(event) => handleListItemClick(event, 0, profileRoute)}
      >
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="View Profile" />
      </ListItemButton> */}
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
